/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Basic_Payment_DescriptionInputs */

const en_admin_settings_groups_basic_payment_description = /** @type {(inputs: Admin_Settings_Groups_Basic_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment general settings`)
};

const zh_admin_settings_groups_basic_payment_description = /** @type {(inputs: Admin_Settings_Groups_Basic_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付通用设置`)
};

/**
* | output |
* | --- |
* | "Payment general settings" |
*
* @param {Admin_Settings_Groups_Basic_Payment_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_basic_payment_description = /** @type {((inputs?: Admin_Settings_Groups_Basic_Payment_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Basic_Payment_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_basic_payment_description(inputs)
	return zh_admin_settings_groups_basic_payment_description(inputs)
});
export { admin_settings_groups_basic_payment_description as "admin.settings.groups.basic_payment.description" }